import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl: String = environment.reqBaseUrl + 'auth/';
  authToken: any;
  user: any;
  imgUrl: string = environment.imgBaseUrl;
  private updatedUser: BehaviorSubject<any>;

  constructor(private http: HttpClient, private router: Router) {
    this.updatedUser = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem('user') ?? 'null')
    );
  }

  signUp(payload: any) {
    return this.http.post(this.baseUrl + 'signup', payload, {
      observe: 'response',
    });
  }

  login(payload: any) {
    return this.http.post(this.baseUrl + 'login', payload, {
      observe: 'response',
    });
  }

  checkEmail(email: string) {
    return this.http.get(this.baseUrl + 'status/' + email, {
      observe: 'response',
    });
  }

  resendEmail(email: string) {
    return this.http.post(this.baseUrl + 'resend/confirmation/' + email, null, {
      observe: 'response',
    });
  }

  confirmAccount(token: string, payload: any) {
    return this.http.post(
      this.baseUrl + 'signup/' + token + '/confirmation',
      payload,
      {
        observe: 'response',
      }
    );
  }

  forgotPassword(payload: any) {
    return this.http.post(this.baseUrl + 'forgot/password', payload, {
      observe: 'response',
    });
  }

  resetPassword(token: string, payload: any) {
    return this.http.post(this.baseUrl + 'reset/password/' + token, payload, {
      observe: 'response',
    });
  }

  setPassword(payload: any) {
    return this.http.post(this.baseUrl + 'forgot', payload, {
      observe: 'response',
    });
  }

  getUserData(token: string) {
    return this.http.get(this.baseUrl + 'confirmation/' + token, {
      observe: 'response',
    });
  }

  confirmation(token: string, payload: any) {
    return this.http.post(this.baseUrl + 'confirmation/' + token, payload, {
      observe: 'response',
    });
  }

  sendPaymentMethod(token: string) {
    return this.http.get(this.baseUrl + 'enroll/' + token, {
      observe: 'response',
    });
  }

  decryptObject(token: string) {
    return this.http.get(this.baseUrl + 'object/' + token, {
      observe: 'response',
    });
  }

  storeUserData(token?: string, user?: any) {
    if (token) {
      localStorage.setItem('token', token);
      this.authToken = token;
    }
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
      this.user = user;
    }
  }

  getUser(): Observable<any> {
    return this.updatedUser.asObservable();
  }
  setUser(newValue: any): void {
    this.updatedUser.next(newValue);
  }

  loggedIn(): boolean {
    return localStorage.getItem('token') !== null;
  }

  logOut() {
    this.authToken = null;
    this.user = null;
    localStorage.clear();
    this.router.navigate(['/signin']);
  }
}
